module.exports = __webpack_public_path__ + "static/media/vip-access-store-tile-3-promo.29e8e7f8.png";